
import SharedContentListContainer from 'containers/SharedContentContainer/SharedContentListContainer';

export const SharedBenchmarksListScreen = () => (
  <SharedContentListContainer listType="benchmarks" />
);

export default SharedBenchmarksListScreen;
